import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GreenroomState as GRS } from '../../stores/types/types';
import { setModalClosed, setModalState } from '../../stores/actions/modal';
import { MODAL_TEMPLATES } from '../../stores/reducers/modal';

// this hook exists to detect multiple accounts logged in from the same user
// and open the modal view that will either kick users or redirect them to the home page
// this is a single use hook that should only be rendered in app.tsx
const useDetectMultiAccount = (): void => {
    const dispatch = useDispatch();
    const connectedUsers = useSelector((state: GRS) => state.SessionReducer.connectedUsers);
    const userId = useSelector((state: GRS) => state.SessionReducer.user?.gr_user);
	const onboardingComplete = useSelector((state: GRS) => state.SessionReducer.onboardingComplete);
	const modalTemplate = useSelector((state: GRS) => state.ModalReducer.modalTemplate);

	const [doBlockModal, setDoBlockModal] = useState(false);
	useEffect(() => {
		const doBlock = window.location.search.includes('can-multi-account=true');
		if (doBlock) {
			setDoBlockModal(true);
		}
	}, []);

	const myUserObjects = connectedUsers.filter(
		(u) => ((userId && u.gr_user && u.gr_user === userId && !u.companionMode))
	).filter((u) => u.in_room);

    useEffect(() => {
		if (!userId || doBlockModal) return;
		
		if (myUserObjects.length > 1 && onboardingComplete) {
			dispatch(setModalState({
				modalOpen: true,
				modalTemplate: MODAL_TEMPLATES.MULTI_ACCOUNT_LOGGED_IN,
			}));
		} else if (modalTemplate === MODAL_TEMPLATES.MULTI_ACCOUNT_LOGGED_IN) {
			dispatch(setModalClosed());
		}
	}, [
		userId,
		myUserObjects,
		onboardingComplete,
		modalTemplate,
		doBlockModal
	]);
};

export default useDetectMultiAccount;
